module.exports = __webpack_public_path__ + "img/fundingResolutionLogo8.5e224fa3.png";